import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { generateParamsFromObj } from "@/common/utils";
import { axiosInstance } from "../../axios";
import { IDocumentType, PaginatedResponseWithTotal } from "@/common/types";

const getDocumentsMe = async (
  type: string,
  skip: number,
  filter: Record<string, any>,
  searchQ: string
) => {
  const params = generateParamsFromObj(filter);
  const take = 10;

  const searchFields = [
    "description",
    "companyName",
    "productName",
    "documentName",
  ];

  params.append("type", type);
  params.append("take", take.toString());
  params.append("skip", skip.toString());
  params.append("searchQ", searchQ);
  searchFields.forEach((el) => params.append("searchFields", el));

  return await axiosInstance
    .get("documents/byCompany", { params })
    .then((res) => res.data)
    .catch((e) => {
      throw e;
    });
};

const useGetDocumentsMe = (
  type: string,
  skip: number,
  filter: Record<
    string,
    string | string[] | number[] | Record<string, string | string[] | number[]>
  >,
  searchQ: string
) => {
  return useQuery<PaginatedResponseWithTotal<IDocumentType>>({
    queryKey: [type, skip, filter, searchQ],
    queryFn: () => getDocumentsMe(type, skip, filter, searchQ),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
  });
};
export default useGetDocumentsMe;
